import React from 'react';

const ListingsViewToggle = ({ view, onChange }) => (
  <div className="listings-view-toggle" role="group" aria-label="Listing view">
    <button type="button" className={view === "grid" ? "active" : ""} onClick={() => onChange("grid")}>
      <i className="fas fa-th-large" aria-hidden="true"></i> Grid
    </button>
    <button type="button" className={view === "map" ? "active" : ""} onClick={() => onChange("map")}>
      <i className="fas fa-map-marked-alt" aria-hidden="true"></i> Map
    </button>
  </div>
);

export default ListingsViewToggle;
